import React from 'react';
import styled from 'styled-components';
import noImage from '../assets/no-image-640x400.jpg';

const Card = styled.div`
  border: 1px solid var(--bdr);
  border-radius: 16px;
  background: var(--card);
  box-shadow: var(--shadow);
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.15);
  }
`;

const ImageBox = styled.div`
  width: 100%;
  height: 200px;
  position: relative;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.3s ease;
  }
  
  ${Card}:hover & img {
    transform: scale(1.05);
  }
`;

const Content = styled.div`
  padding: 16px;
  
  h3 {
    margin: 0 0 8px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.3;
  }
  
  p {
    margin: 0;
    color: var(--muted);
    font-size: 14px;
    line-height: 1.4;
  }
`;

export default function AmenityTile({
  title,
  image,    // URL превью (если есть)
  subtitle, // подпись/категория
}) {
  // Используем изображение из API или заглушку
  const displayImage = image || noImage;
  
  return (
    <Card>
      <ImageBox>
        <img 
          src={displayImage} 
          alt={title} 
          loading="lazy" 
          decoding="async"
          sizes="(max-width: 640px) 100vw, (max-width: 1100px) 50vw, 33vw"
        />
      </ImageBox>

      <Content>
        <h3>{title}</h3>
        {subtitle && <p>{subtitle}</p>}
      </Content>
    </Card>
  );
}
